import { NewsletterEndpoints } from "shared/models/endpoits/newsletter.endpoint";
import { INewsletterResponse } from "shared/models/interfaces/response/newsletter.interface";
import { SubscriptionFormSchemaType } from "@components/footer/components/subscription-form/util/subscriptionForm";
import { postRequest } from "./base-services.request";

export const postSubscription = async ({
  email,
  name,
  interests,
  captcha,
}: SubscriptionFormSchemaType): Promise<INewsletterResponse> => {
  return postRequest(NewsletterEndpoints.Subscription, {
    email,
    name,
    interests,
    "g-recaptcha-response": captcha,
    lists: [2],
  }).then((response) => response.data);
};
